import React from "react";
import EntityForm from "../CRUD/EntityForm/EntityForm";
import priceFeedConfig from "../SelentaPriceFeed/ModuleDefinition";
import { FormattedMessage, defineMessages } from "react-intl";
import { Button } from "react-bootstrap";

const messages = defineMessages({
  download: {
    id: "app.priceFeed.submit",
    description: "Download feed",
    defaultMessage: "Download",
  },
});
function DownloadButton() {
  return (
    <Button type="submit" bsClass="btn btn-info">
      <FormattedMessage {...messages.download} />
    </Button>
  );
}

function BackButton() {
  return null;
}

class SelentaPriceFeedForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleSubmit = this.handleSubmit.bind(this);
    const { wbkLocale: locale = "es" } = window;
    this.config = priceFeedConfig({
      locale,
    });
  }

  componentDidMount() {}

  componentWillUnmount() {}

  getFields(fields) {
    return fields && fields.form;
  }

  handleSubmit({ formValues }) {
    const { startDate, endDate } = formValues;
    const url =
      this.config.restConfig.baseURL +
      "/" +
      this.config.restConfig.fetch.url() +
      `?startDate=${startDate}&endDate=${endDate}`;
    window.open(url);
  }

  /* Handle Errors */
  render() {
    const { name, validation, fields, renderers, translation, entities } = this.config;
    const {
      entity = {},
      entityError = false,
      entityResult = false,
      loading = false,
      getListPath = () => ({}),
    } = this.props;
    const { wbkLocales: locales = ["en", "es"] } = window;
    const { getFields, handleSubmit } = this;
    return (
      <div>
        <EntityForm
          loading={loading}
          name={name}
          entity={entity}
          entities={entities}
          validation={validation}
          renderers={renderers}
          fields={getFields(fields)}
          locales={locales}
          translation={translation}
          onSubmit={handleSubmit}
          entityError={entityError}
          entityResult={entityResult}
          getListPath={getListPath}
          SubmitButton={DownloadButton}
          BackButton={BackButton}
        />
      </div>
    );
  }
}

SelentaPriceFeedForm.propTypes = {};

SelentaPriceFeedForm.defaultProps = {
  locales: ["es", "ca", "en", "fr", "it", "de"],
};

export default SelentaPriceFeedForm;
